import { h } from 'preact'

export const OccasionnelAutopromo = (props) => {
   try {
      const { advCanal, url, refZone, isAdvise, offerSpecificationCode, parentOfferSpecificationCode, alt, idc, images, adv_tracker, cacheKey } = props[0]

      let pdbIdc
      let cappingAdv
      if (isAdvise) {
         pdbIdc = offerSpecificationCode
         if (parentOfferSpecificationCode !== '') {
            pdbIdc += ',' + parentOfferSpecificationCode
         }
         cappingAdv = {
            'data-adv-canal': advCanal,
            'data-adv-cappingdata': `{'m': '${offerSpecificationCode}','p': '${parentOfferSpecificationCode}','t': '${adv_tracker}'}`,
         }
      } else {
         pdbIdc = idc
      }
      return (
         <a
            href={url}
            class="d-block overflow-hidden"
            data-pdb-zid={refZone}
            data-pdb-sc={isAdvise ? 'adv' : 'mpt'}
            data-pdb-idc={pdbIdc}
            data-pdb-vi={isAdvise ? `${images.urlImageResize}${images.img112}` : images.img3}
            data-pdb-ta={isAdvise ? adv_tracker : ''}
            {...cappingAdv}
            data-cache-key={cacheKey ? cacheKey : ''}
            data-oevent-category="top_foisonnement-a"
            data-oevent-action={alt}
            data-oevent-label={url}
            data-oevent-other={`{"track_refZ":"${refZone}"}`}
         >
            {isAdvise ? (
               <picture>
                  <source srcset={`${images.urlImageResize}${images.img112}?format=1080x324&saveas=webp`} media="(max-width: 959px)" />
                  <source srcset={`${images.urlImageResize}${images.img112}?format=1200x360&saveas=webp`} media="(max-width: 1199px)" />
                  <img src={`${images.urlImageResize}${images.img112}?format=1500x450&saveas=webp`} alt={alt} loading="lazy" />
               </picture>
            ) : (
               <picture>
                  <source srcset={images.img1} media="(max-width: 959px)" />
                  <source srcset={images.img2} media="(max-width: 1199px)" />
                  <img src={images.img3} alt={alt} loading="lazy" />
               </picture>
            )}
         </a>
      )
   } catch (error) {
      console.error('occasionnel-autopromo.jsx', error)
   }
}
